namespace Gamification.Gamification {
    export interface TipologieCaricamentiForm {
        Nome: Serenity.StringEditor;
        Descrizioni: Serenity.StringEditor;
    }

    export class TipologieCaricamentiForm extends Serenity.PrefixedContext {
        static formKey = 'Gamification.TipologieCaricamenti';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!TipologieCaricamentiForm.init)  {
                TipologieCaricamentiForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;

                Q.initFormType(TipologieCaricamentiForm, [
                    'Nome', w0,
                    'Descrizioni', w0
                ]);
            }
        }
    }
}
